import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { CoreModule } from 'src/app/core/core.module';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { MessagesModule } from 'primeng/messages';
import { InputTextarea } from 'primeng/inputtextarea';
import { VOIPRoutingModule } from './voip-routing.module';
import { ExtensionsListComponent } from './extensions/extensions-list/extensions-list.component';
import { ExtensionsDetailComponent } from './extensions/extensions-detail/extensions-detail.component';
import { VOIPCDRComponent } from './cdr/cdr.component';
import { VOIPStatusComponent } from './status/status.component';
import { TooltipModule } from 'primeng/tooltip';
import { BadgeModule } from 'primeng/badge';
import { TagModule } from 'primeng/tag';
import { Recording } from '../phone/_types/recording';
import { RecordingDetailComponent } from './cdr/recording/recording-detail.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import { TimelineModule } from 'primeng/timeline';
import { VoipScheduleConfigComponent } from './schedule-config/voip-schedule-config.component';
import { QueuesListComponent } from './queues/queues-list/queues-list.component';
import { QueuesDetailComponent } from './queues/queues-detail/queues-detail.component';
import { QueueMemberAddComponent } from './queues/queue-member-add/queue-member-add.component';
import { DialPlansListComponent } from './dial-plans/dial-plans-list/dial-plans-list.component';
import { DialPlansDetailComponent } from './dial-plans/dial-plans-detail/dial-plans-detail.component';
import { DialPlanActionEditComponent } from './dial-plans/dial-plan-action-edit/dial-plan-action-edit.component';
import { DialPlanFlowComponent } from './dial-plans/dial-plan-flow/dial-plan-flow.component';
import { FFlowModule } from '@foblex/flow';
import { DDIsListComponent } from './ddis/ddis-list/ddis-list.component';
import { DDIsDetailComponent } from './ddis/ddis-detail/ddis-detail.component';


@NgModule({ declarations: [
        ExtensionsListComponent,
        ExtensionsDetailComponent,
        VOIPCDRComponent,
        VOIPStatusComponent,
        RecordingDetailComponent,
        VoipScheduleConfigComponent,
        QueuesListComponent,
        QueuesDetailComponent,
        QueueMemberAddComponent,
        DialPlansListComponent,
        DialPlansDetailComponent,
        DialPlanActionEditComponent,
        DialPlanFlowComponent,
        DDIsListComponent,
        DDIsDetailComponent
    ], imports: [CoreModule,
        CommonModule,
        CardModule,
        ButtonModule,
        CheckboxModule,
        InputTextModule,
        PasswordModule,
        FormsModule,
        TableModule,
        CardModule,
        TabViewModule,
        CalendarModule,
        MessagesModule,
        VOIPRoutingModule,
        ReactiveFormsModule,
        InputTextModule,
        InputSwitchModule,
        ConfirmDialogModule,
        DropdownModule,
        DynamicDialogModule,
        InputTextarea,
        FFlowModule,
        TooltipModule,
        BadgeModule,
        TagModule,
        MultiSelectModule,
        DialogModule,
        TimelineModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class VOIPModule { }
